export default __webpack_public_path__ + "static/media/dan_thumb.7de8faac.jpg";